import { Breadcrumb } from '@doltech/ui/lib/figma/Breadcrumb';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { deviceBreakpoints } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import * as React from 'react';
import styled from 'styled-components';

import { AuthorPreview } from './AuthorPreview';

const Main = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  padding-bottom: 24px;
  border-bottom: 1px solid ${colorsV2.gray20};

  .description {
    white-space: pre-wrap;
  }

  .section-author {
    display: grid;

    .section-author-info {
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      grid-auto-columns: max-content;
      gap: 8px;
      border-bottom: 1px solid ${colorsV2.gray10};
      padding-bottom: 16px;
    }
    .section-author-extra-info {
      display: grid;
    }
    .author-extra-info {
      display: grid;
      gap: 8px;
      grid-auto-flow: column;
      align-items: center;
      grid-auto-columns: max-content;
    }
    .section-author-actions {
      display: grid;
      align-items: center;
      grid-auto-flow: column;
      grid-auto-columns: max-content;
      gap: 8px;
      border-bottom: 1px solid ${colorsV2.black10};
      .btn-action {
        background-color: transparent;
        border: none;
        cursor: pointer;

        padding: 10px 16px;
        display: grid;
        grid-auto-flow: column;
        align-items: center;
        gap: 8px;
        grid-template-columns: max-content;
        transition: all 0.2s ease;
        &:hover {
          transform: scale(1.02);
        }
        &:active {
          transform: scale(0.98);
        }
        .action-icon {
          font-size: 24px;
          line-height: 0;
        }
      }
      .fb-share {
        display: grid;
        grid-auto-flow: column;
        align-items: center;
        gap: 8px;
        grid-template-columns: max-content;
        transition: all 0.2s ease;
        .action-icon {
          font-size: 20px;
          line-height: 0;
        }
        &:hover {
          transform: scale(1.02);
        }
        &:active {
          transform: scale(0.98);
        }
      }
    }
  }

  @media ${deviceBreakpoints.fromTablet} {
    .section-author {
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      justify-content: space-between;
      .section-author-extra-info {
        display: grid;
        grid-auto-flow: column;
        align-items: center;
        grid-auto-columns: max-content;
        gap: 8px;
      }
      .section-author-info {
        border-bottom: none;
        padding-bottom: 0;
      }
      .section-author-actions {
        border-bottom: none;
        .btn-action {
          padding: 0;
          .button-text {
            display: none;
          }
        }
        .fb-share {
          .action-icon {
            font-size: 28px;
          }
        }
      }
    }
  }
`;

export const IeltsSampleHeader = ({
  routes,
  title,
  description,
  lastModifiedAt,
  length,
  seoData,
}) => {
  return (
    <Main className="ielts-sample-header">
      <Breadcrumb useFor="landing" routes={routes} seoData={seoData} />

      <ResponsiveTypography.Title
        mt="32px"
        className="font-noto"
        level={1}
        variant={['semi-bold/32-41.6', 'semi-bold/42-54.6', 'semi-bold/42-54.6']}
        breakpoints={[0, 776, 777]}
      >
        {title}
      </ResponsiveTypography.Title>

      <ResponsiveTypography.Paragraph
        mt="16px"
        mb="32px"
        className="description font-noto"
        color="gray100"
        variant={['regular/16-25.6', 'regular/20-32', 'regular/20-32']}
        breakpoints={[0, 776, 777]}
      >
        {description}
      </ResponsiveTypography.Paragraph>

      <AuthorPreview seoData={seoData} lastModifiedAt={lastModifiedAt} length={length} />
    </Main>
  );
};
